/**
 * JoinSLJoinPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinSLJoinPage
 */

import { useJoinSLJoinPageLogic } from '@/hooks/traits/useJoinSLJoinPageLogic';
import type { JoinSLJoinPageConfig } from '@/hooks/traits/useJoinSLJoinPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinSLJoinView as JoinSLJoinViewEntity } from '@app/shared';
import { AnimatedReveal } from '@almadar/ui/components';
import { JoinSLJoinHeroView } from '@/components/traits/JoinSLJoinHeroView';
import { JoinSLJoinHeaderView } from '@/components/traits/JoinSLJoinHeaderView';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { JoinSLJoinFooterView } from '@/components/traits/JoinSLJoinFooterView';
import { Stack } from '@almadar/ui/components';
import { JoinSLJoinWeekDemoView } from '@/components/traits/JoinSLJoinWeekDemoView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface JoinSLJoinPageViewProps {
  config?: Partial<JoinSLJoinPageConfig>;
}

export function JoinSLJoinPageView({ config: propsConfig }: JoinSLJoinPageViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinSLJoinPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinSLJoinView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinSL" trait="JoinSLJoinPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="JoinSLJoinPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><JoinSLJoinHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><JoinSLJoinHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box className="py-16 md:py-24" fullWidth={true} bg="transparent"><AnimatedReveal threshold={0.15} trigger="scroll" animation="fade-up"><Container padding="lg" maxWidth="xl" size="xl"><Stack direction="vertical" gap="xl"><Stack align="center" direction="vertical" gap="sm"><Typography weight="bold" content={renderPatternValue(__t("std-almadar-join:week.title"))} align="center" variant="h2" /><Typography variant="large" align="center" color="muted" content={renderPatternValue(__t("std-almadar-join:week.body"))} /></Stack><JoinSLJoinWeekDemoView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack></Container></AnimatedReveal></Box><JoinSLJoinFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default JoinSLJoinPageView;
